import { FeedProviderState } from '@discover/store/models/feed.provider.models';
import { createReducer, on } from '@ngrx/store';
import { WireFeedTypes } from '@src/suite/common/enums/wire-feed-types';
import { FeedProviderActions, FeedProviderApiActions } from '@src/suite/discover/store/actions/feed.provider.actions';

export const initialState: FeedProviderState = {
    isLoading: false,
    isCredentialsDialogOpen: false,
    isFeedDialogOpen: false,

    isCredentialsTabSelected: false,
    isFeedsTabSelected: false,

    inEditMode: false,
    credentials: [],
    currentCredentials: null,
    credentialsTitle: null,
    credentialsType: null,
    apiKey: null,
    credentialsChanged: false,

    feeds: [],
    feedTitle: null,
    feedType: null,

    ftpProviders: [],
    ftpProvider: null,
    ftpUrl: null,
    ftpUsername: null,
    ftpPassword: null,
    ftpDirectory: null,
    ftpFeed: null,

    apCredentialsId: null,
    apProducts: [],
    apSelectedProducts: [],
    apFeed: null,
};

export const feedProviderReducer = createReducer(
    initialState,
    on(FeedProviderActions.initDialog, (state): FeedProviderState => {
        return {
            ...state,
            isLoading: true,
            inEditMode: false,
            isCredentialsDialogOpen: false,
            isFeedDialogOpen: false,
            isCredentialsTabSelected: true,
            isFeedsTabSelected: false,
            currentCredentials: null,
            credentialsTitle: null,
            credentialsType: null,
            apiKey: null,
        };
    }),
    on(FeedProviderActions.initFeeds, (state): FeedProviderState => {
        return {
            ...state,
            isLoading: true,
            inEditMode: false,
            isCredentialsDialogOpen: false,
            isFeedDialogOpen: false,
            isCredentialsTabSelected: false,
            isFeedsTabSelected: true,
            currentCredentials: null,
            credentialsTitle: null,
            credentialsType: null,
            apiKey: null,
        };
    }),
    on(FeedProviderActions.openAddCredentialsDialog, (state): FeedProviderState => {
        return {
            ...state,
            inEditMode: false,
            isCredentialsDialogOpen: true,
            credentialsTitle: null,
            credentialsType: null,
            apiKey: null,
            credentialsChanged: false,
        };
    }),

    on(FeedProviderActions.openEditCredentialsDialog, (state, action): FeedProviderState => {
        return {
            ...state,
            isCredentialsDialogOpen: true,
            inEditMode: true,
            currentCredentials: action.credentials,
            credentialsTitle: action.credentials.name,
            credentialsType: action.credentials.feedType,
            apiKey: action.credentials.credentials,
            credentialsChanged: false,
        };
    }),
    on(FeedProviderActions.openAddFeedDialog, (state): FeedProviderState => {
        return {
            ...state,
            isFeedDialogOpen: true,
            feedTitle: null,
            feedType: null,
            credentialsChanged: false,
        };
    }),

    on(FeedProviderApiActions.getCredentialsAndFeeds, (state, _): FeedProviderState => {
        return {
            ...state,
            isLoading: true,
        };
    }),
    on(FeedProviderApiActions.getCredentialsAndFeedsError, (state, _): FeedProviderState => {
        return {
            ...state,
            isLoading: false,
        };
    }),
    on(FeedProviderApiActions.getCredentialsAndFeedsSuccess, (state, action): FeedProviderState => {
        return {
            ...state,
            isLoading: false,
            credentials: action.credentials,
            feeds: action.feeds,
        };
    }),
    on(FeedProviderApiActions.getWireCredentialsSuccess, (state, action): FeedProviderState => {
        if (action.credentials.feedType === WireFeedTypes.FTP) {
            let credentials = {
                Username: '********',
                Password: '********',
            };
            try {
                credentials = JSON.parse(action.credentials.credentials);
            } catch (e) {
                console.log(e);
            }

            return {
                ...state,
                isLoading: false,
                currentCredentials: action.credentials,
                credentialsTitle: action.credentials.name,
                credentialsType: action.credentials.feedType,
                ftpUsername: credentials.Username,
                ftpPassword: credentials.Password,
                credentialsChanged: false,
            };
        } else {
            return {
                ...state,
                isLoading: false,
                currentCredentials: action.credentials,
                credentialsTitle: action.credentials.name,
                credentialsType: action.credentials.feedType,
                apiKey: action.credentials.credentials,
                credentialsChanged: false,
            };
        }
    }),

    on(FeedProviderActions.updateCredentialsTitle, (state, action): FeedProviderState => {
        return {
            ...state,
            credentialsTitle: action.credTitle,
        };
    }),
    on(FeedProviderActions.updateFeedTitle, (state, action): FeedProviderState => {
        return {
            ...state,
            feedTitle: action.feedTitle,
        };
    }),
    on(FeedProviderActions.updateCredentialsType, (state, action): FeedProviderState => {
        return {
            ...state,
            credentialsType: action.credType,
        };
    }),
    on(FeedProviderActions.updateCredentialsApiKey, (state, action): FeedProviderState => {
        return {
            ...state,
            apiKey: action.apiKey,
            credentialsChanged: true,
        };
    }),
    on(FeedProviderActions.updateFtpProvider, (state, action): FeedProviderState => {
        return {
            ...state,
            ftpProvider: action.ftpProvider,
        };
    }),
    on(FeedProviderActions.updateFtpUrl, (state, action): FeedProviderState => {
        return {
            ...state,
            ftpUrl: action.ftpUrl,
        };
    }),
    on(FeedProviderActions.updateFtpUsername, (state, action): FeedProviderState => {
        return {
            ...state,
            ftpUsername: action.ftpUsername,
            credentialsChanged: true,
        };
    }),
    on(FeedProviderActions.updateFtpPassword, (state, action): FeedProviderState => {
        return {
            ...state,
            ftpPassword: action.ftpPassword,
            credentialsChanged: true,
        };
    }),
    on(FeedProviderActions.updateFtpDirectory, (state, action): FeedProviderState => {
        return {
            ...state,
            ftpDirectory: action.ftpDirectory,
        };
    }),
    on(FeedProviderApiActions.createWireCredentialsSuccess, (state, _): FeedProviderState => {
        return {
            ...state,
            isLoading: false,
            currentCredentials: null,
            credentialsTitle: null,
            credentialsType: null,
            apiKey: null,
        };
    }),
    on(FeedProviderActions.updateFeedType, (state, action): FeedProviderState => {
        return {
            ...state,
            feedType: action.feedType,
        };
    }),
    on(FeedProviderApiActions.getProvidersSuccess, (state, action): FeedProviderState => {
        return {
            ...state,
            ftpProviders: action.providers,
        };
    }),
    on(FeedProviderActions.updateApCredentailsId, (state, action): FeedProviderState => {
        return {
            ...state,
            apCredentialsId: action.apCredentialsId,
        };
    }),
    on(FeedProviderApiActions.getAPFeedProductsSuccess, (state, action): FeedProviderState => {
        return {
            ...state,
            apProducts: action.products,
        };
    }),
    on(FeedProviderActions.updateSelectedProducts, (state, action): FeedProviderState => {
        return {
            ...state,
            apSelectedProducts: action.products,
        };
    }),
    on(
        FeedProviderApiActions.getAPFeedProducts,
        FeedProviderApiActions.createWireCredentials,
        FeedProviderApiActions.updateWireCredentials,
        FeedProviderApiActions.createAPFeed,
        FeedProviderApiActions.updateAPFeed,
        FeedProviderApiActions.createFTPFeed,
        (state, _): FeedProviderState => {
            return {
                ...state,
                isLoading: true,
            };
        }
    ),
    on(
        FeedProviderApiActions.getAPFeedProductsSuccess,
        FeedProviderApiActions.getAPFeedProductsError,
        FeedProviderApiActions.createWireCredentialsSuccess,
        FeedProviderApiActions.createWireCredentialsError,
        FeedProviderApiActions.updateWireCredentialsSuccess,
        FeedProviderApiActions.updateWireCredentialsError,
        FeedProviderApiActions.createAPFeedSuccess,
        FeedProviderApiActions.createAPFeedError,
        FeedProviderApiActions.updateAPFeedSuccess,
        FeedProviderApiActions.updateAPFeedError,
        FeedProviderApiActions.createFTPFeedSuccess,
        FeedProviderApiActions.createFTPFeedError,
        (state, _): FeedProviderState => {
            return {
                ...state,
                isLoading: false,
            };
        }
    ),
    on(FeedProviderActions.initDialog, (state, _): FeedProviderState => {
        return {
            ...state,
            isLoading: false,
            isCredentialsTabSelected: true,
            isFeedsTabSelected: false,
        };
    }),
    on(FeedProviderApiActions.createAPFeedSuccess, FeedProviderApiActions.updateAPFeedSuccess, FeedProviderApiActions.createFTPFeedSuccess, (state, _): FeedProviderState => {
        return {
            ...state,
            isLoading: false,
            isCredentialsDialogOpen: false,
            isFeedDialogOpen: false,
            isCredentialsTabSelected: false,
            isFeedsTabSelected: true,
        };
    }),
    on(FeedProviderApiActions.getAPFeedSuccess, (state, action): FeedProviderState => {
        const selectedProducts = action.feed.productId.split(',').map(id => id.trim());
        return {
            ...state,
            isLoading: false,
            isCredentialsDialogOpen: false,
            isFeedDialogOpen: true,
            inEditMode: true,
            apCredentialsId: action.feed.wireCredentialsId,
            apSelectedProducts: selectedProducts,
            feedTitle: action.feed.name,
            apFeed: action.feed,
            feedType: WireFeedTypes.AP,
        };
    }),
    on(FeedProviderApiActions.getFTPFeedSuccess, (state, action): FeedProviderState => {
        return {
            ...state,
            isLoading: false,
            isCredentialsDialogOpen: false,
            isFeedDialogOpen: true,
            inEditMode: true,
            feedTitle: action.feed.name,
            ftpFeed: action.feed,
            feedType: WireFeedTypes.FTP,
            ftpProvider: action.feed.providerId,
            ftpUrl: action.feed.url,
            ftpDirectory: action.feed.directory,
            credentialsChanged: false,
        };
    })
);
